import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgAanbellenDeurbel = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      d="M15.6 14.25a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
    <path
      fill="#fff"
      d="M15.6 12.49a2.24 2.24 0 1 0 0-4.48 2.24 2.24 0 0 0 0 4.48"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M24.25 10.25v4h-1v-6h1a1.5 1.5 0 0 0 1.5 1.5v1a2.5 2.5 0 0 1-1.5-.5"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M22.75 13.75a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M29.6 7.19v2.75h-1V5.19h1a1.5 1.5 0 0 0 1.5 1.5v1a2.5 2.5 0 0 1-1.5-.5"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M28.1 9.44a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="M26.22 19a1.75 1.75 0 0 0-1.78 1.71v-1.28a1.78 1.78 0 0 0-3.55 0 1.78 1.78 0 0 0-3.56 0v-7.74A1.71 1.71 0 0 0 15.58 10h-.05a1.71 1.71 0 0 0-1.75 1.69v10.64A3.09 3.09 0 0 0 12 25.09v2.4A6.63 6.63 0 0 0 18.75 34h2.5A6.64 6.64 0 0 0 28 27.57v-6.86A1.75 1.75 0 0 0 26.22 19"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgAanbellenDeurbel);

export default ForwardRef;
